// extracted by mini-css-extract-plugin
module.exports = {"balanceBlock":"wallet_balanceBlock__2CaDI"};